import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
    Box,
    Collapse,
    IconButton,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'; 
import CreateIcon from '@material-ui/icons/Create';
import ModalEditar from './NvoEditRefaccion'
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaRefaccion({ listRefaccion, filtroSerie, filtroNoEco, filtroDescr, funcionActualizar, listMarca}) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [registro, setRegistro] = useState([]);
    const [open, setOpen] = useState(false);

    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    

    useEffect(() => {                  

        guardarDatos(listRefaccion)
        return () => {
            source.cancel();
        }
    }, [listRefaccion]);

 
    /* const getListTabla = (Maquinaria) => {        
        
        const data = qs.stringify({
            Usuario:idusu,
            Maquinaria: Maquinaria,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/bitacora";

        function respuestaListTabla(aux) {
            if (aux[0].Id !== -1) {
                setListBit(aux)
                
            } 
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEsperaTabBit, history, source);
    }; */

    const seleccionado = (auxReg) => {
        setRegistro(auxReg)
             
    }

    function editarReg(auxFalla) {
        setSeleccionadoEdit(auxFalla)        
        setModalAbierto(true)
    }

    function verMas(auxId) {

        if (auxId === registro) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo
    }

    const obtnMarca=(valor)=>{
        let nvo=""
        const filtro = listMarca.filter((marca)=>marca.Id === valor)
        nvo = filtro[0].Descr
        return nvo
    }

    function Row(props) {
        const {row} = props;

        return (
        <>
            <TableRow onClick={() => { seleccionado(row); }}
                className={classes.tableRow} selected={registro?.Id === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >
         
              <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                    <Tooltip title={'Editar'}>
                        <IconButton aria-label="add circle" size="small" onClick={() => editarReg(row)}
                            component="span">
                            {registro?.Id === row.Id ? <CreateIcon style={{color: 'white'}}/> :
                                <CreateIcon color="primary"/>}
                        </IconButton>
                    </Tooltip>
                </TableCell>  
             {/*    <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>                                        
                    { 
                        <FiberManualRecordIcon style={{color: row.Col}} />}                    
                </TableCell>   */}
               {/* <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 75 + 'px'}}>
                    {moment.utc(row.Freg).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell>      */}        
                <TableCell className={classes.tableCell} align="left" padding={'none'}
                    style={{  width: 100 + 'px', paddingLeft:".5rem"}}>
                    {  minuscula( row.Descr) }
                </TableCell>                                
               {/*  <TableCell className={classes.tableCell} align="left" padding={'none'}
                    style={{  width: 140 + 'px', paddingLeft:".5rem"}}>
                    {obtnMarca( row.MarcaId)}
                </TableCell> */}
            </TableRow>         
        </>
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>                                        
                    <TableCell align="center" padding='none'>{`${auxlista.length}  `}</TableCell>                       
                  {/*   <TableCell align="center" padding='none'>Color</TableCell> */}
                    {/* <TableCell align="center" padding='none'>Fecha Registro</TableCell> */}                                        
                    <TableCell align="center" padding='none'>Descripción</TableCell>      
                    {/* <TableCell align="center" padding='none'>Marca</TableCell>                      */}                   
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => {
                   if (row.Id!==0 && row.Id!=="0" ) {
                    return <Row key={row.Id} row={row}/>
                   } 
                })) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">  </TableCell>
                        <TableCell align="left">Fecha</TableCell>
                        <TableCell align="left">Estatus</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow
                        className={classes.tableRow}
                    >
                        <TableCell className={classes.tableCell} align="center"></TableCell>
                        <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left">Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                    <TableCell className={classes.tableCell} align="center"> </TableCell>
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    function filtro(campo,cadena) {
        let info = []
        if (cadena.length !== 0) {
            let auxCadena = cadena.trim();
            info = datos.filter((dat) => dat[campo].toString().search(auxCadena.toUpperCase()) !== -1)

        } 

        let metodos = null
        if (info.length > 0) {
            metodos = tablaCompleta(info)
        } else {
            metodos = tablaSinResultados()
        }
        return metodos;
    }

    const modEdit = modalAbierto ? <ModalEditar modalAbierto={modalAbierto} setModalAbierto={setModalAbierto} listMarca={listMarca}
                                        titulo={`Editar Refacción`} regis={registro} funcionActuliza={funcionActualizar} /> :null
    const contenido4 = filtroDescr  !==""  ? filtro("Descr", filtroDescr) : tablaCompleta(datos)
    const contenido3 = filtroSerie  !==""  ? filtro("Serie", filtroSerie) : contenido4
    const contenido2 = filtroNoEco !=="" ? filtro("NoEco", filtroNoEco) : contenido3
    const contenido = datos.length !== 0 ? contenido2 : tablaSinDatos()
    const tabla =contenido// espera ? (<Box><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        <Typography>Lista de Refacciones</Typography>
        {tabla}
        {modEdit}
        
    </Paper>
    );
}